import { render, staticRenderFns } from "./GroupList.vue?vue&type=template&id=a7e697b0&scoped=true&"
import script from "./GroupList.vue?vue&type=script&lang=js&"
export * from "./GroupList.vue?vue&type=script&lang=js&"
import style0 from "./ChatInfo.scss?vue&type=style&index=0&id=a7e697b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e697b0",
  null
  
)

export default component.exports